// plugins/magic-image.client.js
export default defineNuxtPlugin((nuxtApp) => {
    const { init, refresh } = useMagicImage()

    // initial client render
    onNuxtReady(() => {
        init();
    });
    // every subsequent navigation
    nuxtApp.hooks.hook('page:finish', () => {
        refresh()
    })
})
